import UnsupportedOperationError from "./UnsupportedOperationError.mjs";
class NotImplementedError extends UnsupportedOperationError {}
export default NotImplementedError;